import service from '../utils/request';

// 获取角色列表
export const getRoleList = (params) => {
  return service.get('/roles', { params });
};

// 获取角色详情
export const getRoleDetail = (id) => {
  return service.get(`/roles/${id}`);
};

// 创建角色
export const createRole = (data) => {
  return service.post('/roles/simple', data);
};

// 更新角色
export const updateRole = (id, data) => {
  return service.put(`/roles/${id}`, data);
};

// 删除角色
export const deleteRole = (id) => {
  return service.delete(`/roles/${id}`);
};

// 修改角色状态
export const updateRoleStatus = (id, status) => {
  return service.patch(`/roles/${id}/status`, { status });
};

// 获取角色的权限
export const getRolePermissions = (roleId) => {
  return service.get(`/roles/${roleId}/permissions`);
};

// 分配角色权限
export const assignRolePermissions = (roleId, permissionIds) => {
  return service.post(`/roles/${roleId}/permissions`, permissionIds );
}; 